import { render, staticRenderFns } from "./editTest.vue?vue&type=template&id=ff9b9d2a&scoped=true"
import script from "./editTest.vue?vue&type=script&lang=js"
export * from "./editTest.vue?vue&type=script&lang=js"
import style0 from "./editTest.vue?vue&type=style&index=0&id=ff9b9d2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff9b9d2a",
  null
  
)

export default component.exports